import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sync } from 'vuex-pathify';
export default {
  name: 'FibLocationPicker',
  components: {
    FibFakeInput: require('@/components/FIBFakeInput').default
  },
  filters: {
    formatAddress: function formatAddress(value) {
      var tmp = value.split(/\n/);

      for (var i = 0; i < tmp.length - 1; i++) {
        tmp[i] = tmp[i].replace('\r', ''); // Remove any additional special break line characters

        tmp[i] = !tmp[i].match(/(,$)/) ? tmp[i] += ',' : tmp[i];
      }

      return tmp.join(' ');
    }
  },
  props: {
    // classes: {
    //   // default: 'col-xl-4 col-lg-5 col-md-8 col-sm-9 col-xs-11', // Narrower on larger screens
    //   default: 'col-xl-6 col-lg-8 col-md-9 col-sm-10 col-xs-11', // Wider on larger screens
    //   type: String
    // },
    branches: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      location: '',
      branchesNearMe: false
    };
  },
  computed: {
    returnedLocation: sync('checkIn/returnedLocation'),
    showBranches: function showBranches() {
      return this.branches && this.branches.length;
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    urlParams: sync('checkIn/urlParams'),
    filteredBranches: function filteredBranches() {
      var _this = this;

      if (!this.branches || !this.branches.length) {
        return [];
      }

      if (!this.location) {
        return this.branches;
      } else {
        return this.branches.filter(function (branch) {
          return (branch.name || '').toLowerCase().indexOf((_this.location || '').toLowerCase()) !== -1 || (branch.address || '').toLowerCase().indexOf((_this.location || '').toLowerCase()) !== -1;
        });
      }
    }
  },
  mounted: function mounted() {
    this.findVenues();
  },
  methods: {
    closeNearBySearch: function closeNearBySearch() {
      this.branchesNearMe = false;
      this.findVenues();
    },
    goBack: function goBack() {
      this.$router.back();
    },
    onLocationSelected: function onLocationSelected(item) {
      this.$emit('location-selected', item);
    },
    getCurrentPosition: function getCurrentPosition() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });
    },
    findVenues: function findVenues() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2$urlParams;

        var branchesNearMe;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                branchesNearMe = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

                // try to get user location info
                // set loading state
                _this2.$q.loading.show({
                  message: _this2.$t('common.misc.loading')
                });

                _this2.branchesNearMe = branchesNearMe;
                _this2.location = '';

                if (branchesNearMe) {
                  _context.next = 8;
                  break;
                }

                _this2.returnedLocation = null;
                _context.next = 19;
                break;

              case 8:
                _context.prev = 8;
                _context.next = 11;
                return _this2.getCurrentPosition();

              case 11:
                _this2.returnedLocation = _context.sent;
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](8);
                Logger.error('geolocationError', _context.t0);
                _this2.branchesNearMe = false;
                _this2.returnedLocation = false;

              case 19:
                _context.next = 21;
                return _this2.$store.dispatch('checkIn/fetchBranches', (_this2$urlParams = _this2.urlParams) === null || _this2$urlParams === void 0 ? void 0 : _this2$urlParams.slug);

              case 21:
                // remove loading state
                _this2.$q.loading.hide();

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 14]]);
      }))();
    }
  }
};